import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

const Reapply = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('Reapply.title')}>
      <ModalActions>
        <LinkButton to={routeMap.application.root} onClick={closeModal}>
          {t('Reapply.button')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default Reapply;
